package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

/**
 * Visibility levels for posts
 */
enum class VisibilityLevel {
    GLOBAL, // Visible to everyone (authenticated and anonymous)
    PUBLIC, // Visible to all authenticated users
    TENANT, // Visible to members of the same tenant
    CIRCLE, // Visible to members of specified circles
    PRIVATE, // Visible only to the author
}

data class Author(
    val id: String, // UUID
    val username: String? = null,
)

data class Post(
    val id: String, // UUID
    val title: String,
    val contentMarkdown: String,
    val contentHtml: String? = null,
    val imageUrl: String? = null, // Deprecated: for backwards compatibility
    val imageIds: List<String> = emptyList(), // UUIDs
    val images: List<PostImage>? = null, // Only in detail response
    val tags: List<Tag>? = null, // Only in detail response
    val status: String? = null,
    val createdAt: Instant,
    val updatedAt: Instant,
    val authorId: String, // UUID
    val author: Author? = null,
    // Multi-tenant fields
    val tenantId: String? = null, // UUID
    val visibility: VisibilityLevel? = null,
    val circleIds: List<String> = emptyList(), // UUIDs
    // Paid content fields
    val isPurchasable: Boolean = false,
    val price: Int? = null, // Price in currency units (e.g., JPY)
    val currency: String? = null, // e.g., "JPY", "USD"
    val isPurchased: Boolean = false,
    val hasAccess: Boolean = true,
    val previewHtml: String? = null, // Preview content (first 20%) for unpaid users
    val fullHtml: String? = null, // Full content (same as contentHtml, for clarity)
)

/**
 * Image associated with a post
 */
data class PostImage(
    val id: String, // UUID
    val url: String,
    val originalName: String,
    val mimeType: String,
    val width: Int? = null,
    val height: Int? = null,
    val caption: String? = null,
    val altText: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val exifData: ExifData? = null, // Exif metadata
)
